import { CloseButton, Drawer } from '@mantine/core';
import { NavFooter, NavItems } from './NavItems';
import classes from './shell.module.css';

interface MobileDrawerProps {
  opened: boolean;
  onClose: () => void;
}

/** Left drawer with the same role-filtered sections as the desktop navbar. */
export function MobileDrawer({ opened, onClose }: MobileDrawerProps) {
  return (
    <Drawer
      opened={opened}
      onClose={onClose}
      position="left"
      size="min(320px, 86%)"
      withCloseButton={false}
      padding={0}
      overlayProps={{ backgroundOpacity: 0.6 }}
      styles={{
        content: {
          background: 'var(--a-shell-bg)',
          color: '#F5F5F2',
          borderRight: '1px solid #2C2C30',
          display: 'flex',
          flexDirection: 'column',
        },
        body: { display: 'flex', flexDirection: 'column', flex: 1, minHeight: 0 },
      }}
      aria-label="Menu"
    >
      <div className={classes.drawerHeader}>
        <img src="/brand/aroo-logo.png" alt="Aroo" />
        <CloseButton
          onClick={onClose}
          aria-label="Close menu"
          size={44}
          iconSize={22}
          style={{ color: '#F5F5F2' }}
        />
      </div>
      <div className={classes.drawerBody}>
        <NavItems size="lg" onNavigate={onClose} />
        <NavFooter />
      </div>
    </Drawer>
  );
}
